import { combineReducers } from 'redux'
import peerAnalysis from './peerAnalysis.reducer'


export default combineReducers({
  peerAnalysis
})
